import { Stores } from 'Constants/Configuration'
import { RootState } from 'store'
import { prepareNumericArray } from './NumericHelper'

const prepareRemoteStores = (state: RootState): number[] => {
  const stores = state.present.configuration.negoziLontani
  if (stores === Stores.All) {
    const excludeStores = prepareNumericArray(state.present.configuration.negoziEscludere)
    if (excludeStores.length > 0) return [0, ...excludeStores]
    else return []
  } else {
    return prepareNumericArray(stores)
  }
}

const dispatchablePrepareStores =
  () =>
  (_, getState): number[] => {
    const state = getState()
    return prepareStores(state)
  }

const prepareStores = (state: RootState): number[] => {
  const activeStore: Stores = state.present.configuration.activeStore
  let stores: string
  switch (activeStore) {
    case Stores.Local:
      stores = state.present.configuration.negozioHome
      break
    case Stores.Nearby:
      stores = state.present.configuration.negoziVicini
      break
    case Stores.Remote:
      stores = state.present.configuration.negoziLontani
      break
  }

  if (stores === Stores.All) {
    const excludeStores = prepareNumericArray(state.present.configuration.negoziEscludere)
    if (excludeStores.length > 0) return [0, ...excludeStores]
    else return []
  } else {
    return prepareNumericArray(stores)
  }
}

const prepareContoVenditaStores = (state: RootState): number[] => {
  return prepareNumericArray(state.present.configuration.negoziContoVendita)
}

const prepareAdmittedCausals = (state: RootState): number[] => {
  return prepareNumericArray(state.present.configuration.causaliAmmesse)
}
const filterStores = (activeStore, currentStoreOption, stores): number[] => {
  if (activeStore !== Stores.Local) {
    return stores
  }
  const storesFiltered =
    currentStoreOption.length > 0 ? stores.filter(store => currentStoreOption.indexOf(store.storeId) !== -1) : stores
  return storesFiltered
}

export {
  dispatchablePrepareStores,
  prepareContoVenditaStores,
  prepareStores,
  prepareRemoteStores,
  prepareAdmittedCausals,
  filterStores,
}
